var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelFoursquareFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#F64978",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M14.911 6.857c.844 0 1.07.46.887 1.315-.24 1.12-.96 4.649-1.024 4.898-.077.296-.195.8-.932.8h-1.754c-.07 0-.07 0-.141.068-.047.044-2.758 3.06-2.758 3.06-.211.234-.564.192-.691.142-.128-.05-.355-.2-.355-.605V7.788c0-.36.233-.93 1.025-.93Zm-.624 1.138H9.68c-.21 0-.35.18-.35.334v6.826c0 .02.017.026.034.007 0 0 1.698-1.954 1.887-2.18.189-.224.274-.26.556-.26h1.55c.21 0 .33-.17.352-.27s.202-1.002.24-1.184c.039-.182-.135-.369-.313-.369h-1.898c-.252 0-.433-.171-.433-.412v-.263c0-.24.18-.405.431-.405h2.238c.158 0 .33-.137.358-.268l.241-1.204a.29.29 0 0 0-.285-.352"
}))));
export default SvgGemChannelFoursquareFilled;